import React from 'react';
import {useRouteMatch} from 'react-router-dom';

import PublicNavDesktop from './PublicNavDesktop';
import PublicNavMobile from './PublicNavMobile';
import {ENABLE_ANALYTICS, ENABLE_ISO_SURVEY} from 'configs/enable-features';
import {useViewport} from 'contexts/ViewportContext';
import {VIEWPORT_WIDTHS} from 'configs';

function PublicNav(props) {
  const {size} = useViewport();
  const isMobile = VIEWPORT_WIDTHS[size] < VIEWPORT_WIDTHS.lg;

  const isActivation = useRouteMatch('/e/act/') !== null;

  const navItems = [
    {
      to: '/',
      text: 'Home',
    },
    {
      text: 'About Us',
      parent: '/about',
      headers: [
        {
          parent: '/about',
          text: 'About Us',
          children: [
            {
              to: '/about/iaf-certsearch',
              text: 'About IAF',
            },
            {
              to: '/about/iaf',
              text: 'International Accreditation Forum',
            },
            {
              to: '/about/iaf-badge',
              text: 'IAF CertSearch Mark',
            },
          ],
        },
      ],
    },
    {
      text: 'Services',
      parent: '/services',
      headers: [
        {
          text: 'Services',
          header: 'VERIFICATION',
          children: [
            {
              to: '/services/certificate-search',
              text: 'Manual Search',
            },
            {
              to: '/services/bulk-certificate-verification',
              text: 'Bulk Verification',
            },

            {
              to: '/services/api-certificate-search',
              text: 'API/SaaS Integration',
            },
          ],
        },
        ENABLE_ANALYTICS && {
          text: 'Services',
          header: 'MARKET INTELLIGENCE',
          children: [
            {
              to: '/services/certificate-market-intelligence',
              text: 'Analytics',
            },
            ENABLE_ISO_SURVEY && {
              to: '/services/iso-survey',
              text: 'ISO Survey',
            },
          ].filter((v) => v),
        },
      ].filter((v) => v),
    },
    {
      text: 'Standards',
      parent: '/standards',
      headers: [
        {
          text: 'Standards',
          header: 'POPULAR STANDARDS',
          parent: '/standards',
          children: [
            {
              to: '/standards/iso-9001-quality-management-systems-qms',
              text: 'ISO 9001',
            },
            {
              to: '/standards/iso-14001-environmental-management-system-ems',
              text: 'ISO 14001',
            },
            {
              to: '/standards/iso-50001-energy-management-systems-enms',
              text: 'ISO 50001',
            },
            {
              to: '/standards/iso-45001-health-and-safety-management-systems-ohs',
              text: 'ISO 45001',
            },
            {
              to: '/standards/iso-27001-information-security-management-isms',
              text: 'ISO 27001',
            },
          ],
        },
      ],
    },
    // {
    //   to: '/search/accreditation-bodies',
    //   text: 'Accreditation Bodies',
    // },
    // {
    //   to: '/search/certification-bodies',
    //   text: 'Certification Bodies',
    // },
    {
      to: '/plans',
      text: 'Plans',
    },
    {
      to: '/contact',
      text: 'Contact',
    },
  ].filter(Boolean);

  return (
    <>
      {isMobile ? (
        <PublicNavMobile navItems={!isActivation ? navItems : []} {...props} />
      ) : (
        <PublicNavDesktop navItems={!isActivation ? navItems : []} {...props} />
      )}
    </>
  );
}

export default PublicNav;
